import type { ReactNode } from 'react'

import { Typography } from '../../../atoms/typography'

type Props = {
  children: ReactNode
  className?: string
}

export const StepHeadlineTitle = ({ children, className }: Props) => (
  <Typography className={className} variant="b2">
    {children}
  </Typography>
)
